export const selectItems = state => state.items.items;
export const selectPrefixes = state => state.items.prefixes;
export const selectError = state => state.items.error;
export const selectPrefix = state => state.items.currentPrefix;